// import { IoIosArrowDown } from "react-icons/io"
// import AdminImage from "../../assets/images/placeholder.jpg"
import { FaPeopleCarry } from "react-icons/fa"
import { RiUser3Fill } from "react-icons/ri"
import { MdSettings } from "react-icons/md"
import { FiLogOut } from "react-icons/fi"
import { NavLink } from 'react-router-dom'
import { useEffect, useState } from "react"
import { GiHamburgerMenu } from "react-icons/gi"
import { auth } from "../../apiConstants"
import { getUserData, logOutAction } from "../../redux/actions/authActions"
import { useDispatch, useSelector } from "react-redux"

const ListArray = [
  {
    Icon: RiUser3Fill,
    title: "View profile",
    route: "profile"
  },
  {
    Icon: MdSettings,
    title: "settings",
    route: "settings",
  },
  {
    Icon: FaPeopleCarry,
    title: "Wallets",
    route: "admins"
  },
]


const TopNav = ({
  handleToggleSidebar,
  handleCollapsedChange,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [openDrop, setOpenDrop] = useState("")

  const dispatch = useDispatch()
  // const history = useHistory()

  const getUser = useSelector(state => state.getAuthUser)
  var authUser = getUser.payload

  useEffect(() => {
    // if (getUser.error) {
    //   logOutAction()
    // }
    const token = sessionStorage.getItem("jwtToken")
    if (!token || authUser.error === "You are unauthorized to perform this action") {
      logOutAction()
    }
    else {
      dispatch(getUserData(auth()))
    }
    // eslint-disable-next-line
  }, [])


  useEffect(() => {
    if (getUser.error) {
      logOutAction()
    }
  }, [getUser])


  return (
    <nav style={{ height: "84.06px" }}
      className="flex justify-between items-center shadow-sm bg-white py-5 px-5 fixed top-0 w-full left-0 z-20">
      <GiHamburgerMenu onClick={() => handleToggleSidebar(true)}
        className="text-2xl md:ml-4 block lg:hidden cursor-pointer transition duration-500 transform hover:-translate-y-1" />
      <label></label>
      <div className="grid gap-4 grid-flow-col justify-end items-center ">
        {
          authUser.user &&
          <div className="flex flex-col text-right pr-4 lg:pr-20">
            <h4 className="text-sm font-semibold uppercase leading-none">{authUser.user.username}</h4>
            <span className="text-xs opacity-60">{authUser.user.email}</span>
          </div>
        }
        {/* <img src={AdminImage} alt="placeholder" className="w-12 h-12 rounded-full" /> */}
        {/* <IoIosArrowDown onClick={() => setOpenDrop(o => !o)} className="text-2xl cursor-pointer" /> */}
        <div className={(openDrop ? "block" : "hidden") + " absolute top-full right-6 z-50 border-2 bg-white shadow-md max-w-xs w-full"}>
          <div className="flex jusify-between items-center px-6 py-3 bg-gray-100">
            {/* <img src={AdminImage} alt="placeholder" className="w-12 h-12 rounded-full mr-8" /> */}
            <div className="flex flex-col text-left">
              {/* <h4 className="text-sm font-semibold uppercase leading-none">Lekia Oluwasegun</h4> */}
              {
                authUser.user &&
                <span className="text-xs opacity-60">{authUser.user.email}</span>
              }
            </div>
          </div>
          <div>
            {
              ListArray.map(item => (
                <NavLink key={item.title} to={`/${item.route}`} activeClassName="bg-blue-100 text-black"
                  className="flex items-center py-1.5 my-2 px-6 transition duration-500 hover:text-gray-400 border-gray-200 cursor-pointer">
                  <item.Icon className="text-2xl mr-3.5" />
                  <p className="text-xs font-medium capitalize">{item.title}</p>
                </NavLink>
              ))
            }
            <div onClick={logOutAction}
              className="flex items-center py-4 my-2 px-6 transition duration-500 hover:text-white border-gray-200 border-t-2 hover:bg-red-500 cursor-pointer">
              <FiLogOut className="text-2xl mr-3.5" />
              <p className="text-xs font-medium capitaliz">Sign out</p>
            </div>

          </div>
        </div>
      </div>
    </nav>
  )
}

export default TopNav
